import { useSyncExternalStore } from 'react';

// useMediaQuery: ob eine Media Query zutrifft (z. B. schmaler Bildschirm); ohne matchMedia (Tests) immer false.
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (notify) => {
      if (typeof window.matchMedia !== 'function') return () => undefined;
      const mq = window.matchMedia(query);
      mq.addEventListener('change', notify);
      return () => mq.removeEventListener('change', notify);
    },
    () => typeof window.matchMedia === 'function' && window.matchMedia(query).matches,
    () => false,
  );
}
